import { supabase } from '@/utils/supabase';
import {
  type HistoryQuery,
  historyRequest,
  historyResponse
} from '../../supabase/functions/_shared/loan-email-history';
export type {
  HistoryItem,
  HistoryQuery,
  HistoryResponse
} from '../../supabase/functions/_shared/loan-email-history';

export async function getLoanEmailHistory(query: HistoryQuery) {
  const { data, error } = await supabase.functions.invoke('loan-email-history', {
    body: historyRequest.parse(query)
  });
  if (error) {
    throw new Error('Unable to load email history. Refresh to try again.');
  }
  return historyResponse.parse(data);
}
